import React, { useEffect } from "react";
import { useSidebar } from "./SidebarContext";
import './navHeader.css';

/**
 * Theme still expects .nav-header in the DOM for some legacy selectors.
 * Visual brand controls live in Header; this node is hidden and only
 * keeps hamburger state in sync with SidebarContext.
 */
const NavHader = () => {
  const { isOpen } = useSidebar();

  useEffect(() => {
    // Keep #main-wrapper.menu-toggle ownership in SideBar; no-op here.
  }, [isOpen]);

  return <div className="nav-header nav-header--hidden" aria-hidden="true" />;
};

export default NavHader;
